import XVType from "../XVType";
import { Infer } from "../types";

class XVPromise<T extends XVType<any>> extends XVType<Promise<Infer<T>>> {
  constructor(readonly PromiseInner: T) {
    super();
  }

  protected check(value: any): Promise<Infer<T>> {
    if (!(value instanceof Promise)) {
      throw new Error(`Value should be a Promise, received ${typeof value}`);
    }
    return value;
  }

  parse(value: any): Promise<Infer<T>> {
    super.parse(value);
    return (value as Promise<any>).then((res) => {
      if (this.PromiseInner) {
        this.PromiseInner.parse(res);
      }
      return res;
    });
  }
}

export default XVPromise;
